
import React, { useEffect, useState } from 'react';
import { Typography, Table, Card, Space, Button, Col, Input, Row, Modal } from 'antd';
import { ListFournisService } from '../../Services/ListFournisService';
import "../../Pages/CSS/DonnesBases.css";
import { Link, useParams } from 'react-router-dom';
//import Title from 'antd/es/typography/Title';
import { ImportOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const ViewFournisseurPage = () => {
  const { numFourn } = useParams();
  const [fournisseurDetails, setFournisseurDetails] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const listFournisService = new ListFournisService()
  const [fileConfirmationVisible, setFileConfirmationVisible] = useState(false);



  useEffect(() => {
    if (numFourn) {
      listFournisService.getOneListFournis(numFourn)
        .then((data) => {
          setFournisseurDetails(data);
         
        })
        .catch((error) => {
          console.error('Erreur lors de la récupération des détails du fournisseur :', error);
        });
    }
  }, [numFourn]);

  

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    const fileReader = new FileReader();

    fileReader.onload = (event) => {
      try {
        const data = event.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const importedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        
        setDataSource(importedData); 
        console.log('Données importées depuis le fichier Excel :', importedData);
      } catch (error) {
        console.error('Erreur lors de la lecture du fichier Excel :', error);
      }
    };

    fileReader.readAsBinaryString(selectedFile);
  };

  const openFileConfirmation = () => {
    setFileConfirmationVisible(true);
  };
  const handleConfirm = () => {
    setFileConfirmationVisible(false);
    const fileInput = document.getElementById('fileInput');
    fileInput.click(); // Déclenche le clic sur l'input de fichier caché
  };

  const coordinates = fournisseurDetails && fournisseurDetails.coordgeo;

  // Conversion de la chaîne de coordonnées en tableau de nombres
  const mapCoordinates = coordinates
    ? {
        lat: parseFloat(coordinates.split(',')[0]),
        lng: parseFloat(coordinates.split(',')[1]),
      }
    : { lat: 0, lng: 0 };
const MON_ZOOM = 100;
  const columns = [
    {
      title: 'N°',
      dataIndex: 'numero',
      key: 'numero',
      className: 'no-wrap-cell',
    },
    {
      title: 'Date F.',
      dataIndex: 'dateFacture',
      key: 'dateFacture',
      className: 'no-wrap-cell',
    },
    {
      title: 'Reçu le',
      dataIndex: 'dateReception',
      key: 'dateReception',
      className: 'no-wrap-cell',
    },
    {
      title: 'Saisie le',
      dataIndex: 'dateSaisie',
      key: 'dateSaisie',
      className: 'no-wrap-cell',
    },
    {
      title: 'N° facture Frs',
      dataIndex: 'numeroFactureFrs',
      key: 'numeroFactureFrs',
      className: 'no-wrap-cell',
    },
    {
      title: 'Montant',
      dataIndex: 'montant',
      key: 'montant',
      className: 'no-wrap-cell',
    },
    {
      title: 'Date compta',
      dataIndex: 'dateCompta',
      key: 'dateCompta',
      className: 'no-wrap-cell',
    },
    {
      title: 'Traitée par',
      dataIndex: 'traiteePar',
      key: 'traiteePar',
      className: 'no-wrap-cell',
    },
    {
      title: 'NB Lettre/BC',
      dataIndex: 'nbLettreBC',
      key: 'nbLettreBC',
      className: 'no-wrap-cell',
    },
  ];
  

  return (
    <div>
  
      <Card      title={
        fournisseurDetails ? (
          <>
            <img
           
              width="40"
              height="40"
              src="https://img.icons8.com/ios-filled/50/supplier.png"
              alt="supplier"
            />
             &nbsp;
            {`${fournisseurDetails.raisoc} : ${fournisseurDetails.intitule}`}
          </>
        ) : (
          ""
        )
      }
extra={
  <Link to="/fournisseurs">
          <Button type="default">Retour</Button>
        </Link>
      
      }>
   
      <Typography.Paragraph>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '18rem' }}>
        {fournisseurDetails && (
           <>
         <div>
    <span><b>Adresse :</b></span> {fournisseurDetails.adresse}<br />
    <span><b>Téléphone Fixe :</b></span> {fournisseurDetails.telFix}<br />
    <span><b>Contact Mobile :</b></span> {fournisseurDetails.portable}<br />
    <span><b>Email :</b></span> {fournisseurDetails.email}<br />
    <span><b>Fax :</b></span> {fournisseurDetails.fax}<br />
    <span><b>Boîte Postale :</b></span> {fournisseurDetails.bp}<br />
    <span><b>Banque :</b></span> {fournisseurDetails.banque}<br />
    <span><b>Code Banque :</b></span> {fournisseurDetails.codeBque}<br />
    <span><b>Code Agence :</b></span> {fournisseurDetails.codeAgence}<br />
    <span><b>Compte Banque :</b></span> {fournisseurDetails.cpteBque}<br />
  </div>
  <div>
    <span><b>Clé RIB :</b></span> {fournisseurDetails.cleRib}<br />
    <span><b>Région :</b></span> {fournisseurDetails.region}<br />
    <span><b>Pays :</b></span> {fournisseurDetails.pays}<br />
    <span><b>Site Web :</b></span> {fournisseurDetails.siteWeb}<br />
    <span><b>Compte :</b></span> {fournisseurDetails.compte}<br />
    <span><b>Date de Création :</b></span> {fournisseurDetails.dateCreation}<br />
    <span><b>Date de Début :</b></span> {fournisseurDetails.dateDebConv}<br />
    <span><b>Date de Fin de Convention :</b></span> {fournisseurDetails.dateFinConv}<br />
  </div>
         </>
         
        )}
        </div>
        <Row gutter={[16, 16]} style={{padding:'20px'}}>
              <Col
                span={6}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
              
                <Input
                  placeholder="Rechercher..."
                 
                  bordered={false}
                  style={{ borderBottom: "1px solid #ccc" }}
                 
                />
              </Col>
              <Col
                span={18}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
               
               <input
        type="file"
        id="fileInput"
      style={{ display: 'none' }}
        onChange={handleFileChange}
      />
         <label htmlFor="fileInput">
        <Button
          style={{ backgroundColor: '#113001', color: 'white' }}
          icon={<ImportOutlined />}
          onClick={openFileConfirmation}
          as="span"
        >
          Charger la facture
        </Button>
      </label>
      <Modal
        title="Importation Factures"
        open={fileConfirmationVisible}
        maskClosable={false}
        onCancel={() => setFileConfirmationVisible(false)}
        footer={[
        
          <Button style={{display: 'block', margin: '0 auto' , backgroundColor: '#113001', color: 'white'}} key="confirm" type="primary" onClick={handleConfirm}>
            Ouvrir
          </Button>,
        ]}
      >
        <p>Cliquer sur le bouton ouvrir pour charger des factures</p>
      </Modal>
                  
              </Col>
            </Row>
        <Table
         dataSource={dataSource}

          /*   rowSelection={rowSelection}
            rowKey={(record) => record.numFourn} */
            scroll={{
              x: true,
            }}
            className="custom-header1-table"
            bordered
            columns={columns}
           
            showSorterTooltip={false}
          />
        {/* Intégration de la carte Google pour l'adresse du fournisseur */}
        <LoadScript googleMapsApiKey="AIzaSyA4NVWGyS_PoQLl64qXR08mjOrjKDvci4Q">
        <GoogleMap center={mapCoordinates} zoom={MON_ZOOM}>
  {coordinates && <Marker position={mapCoordinates} />}
</GoogleMap>
</LoadScript>
      </Typography.Paragraph>
      </Card>
    </div>
  );
};

export default ViewFournisseurPage;


